import { render, staticRenderFns } from "./CurrencyWarOrderList.vue?vue&type=template&id=5a762f33&scoped=true"
import script from "./CurrencyWarOrderList.vue?vue&type=script&lang=js"
export * from "./CurrencyWarOrderList.vue?vue&type=script&lang=js"
import style0 from "./CurrencyWarOrderList.vue?vue&type=style&index=0&id=5a762f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a762f33",
  null
  
)

export default component.exports